import { useEffect, useState } from "react";
import { getApi } from "../utils/api.ts";
import Cookies from "js-cookie";
import { API_ANNOUNCEMENT_DASHBOARD } from "../../config/Endpoints.js";

type ApiSession = {
  id: number;
  title: string;
  eventType: string;
  startDateTime: string;
  endDateTime: string;
  presentedBy?: string;
};

export type DashboardTrainingSession = {
  id: string;
  title: string;
  eventType: string;
  category: string;
  categoryLabel: string;
  startDateTime: string;
  endDateTime: string;
  attendingCount: number;
  presentedBy?: string;
};

type UseTrainingSessionsOptions = {
  enabled?: boolean;
};

export function useTrainingSessions(
  options: UseTrainingSessionsOptions = {},
) {
  const enabled = options.enabled !== false;
  const [data, setData] = useState<DashboardTrainingSession[]>([]);
  const [loading, setLoading] = useState(false);
  const accessToken = Cookies.get("accessToken");

  useEffect(() => {
    if (!enabled) return;

    const fetchData = async () => {
      setLoading(true);
      try {
        const res = await getApi<any>(API_ANNOUNCEMENT_DASHBOARD, accessToken);

        const rows = Array.isArray(res?.data?.data?.data)
          ? res.data.data.data.map((item: ApiSession) => ({
              id: String(item.id),
              title: item.title,
              eventType: item.eventType,
              category: "training",
              categoryLabel: item.eventType,
              startDateTime: item.startDateTime,
              endDateTime: item.endDateTime ?? item.startDateTime,
              attendingCount: 0,
              presentedBy: item.presentedBy,
            }))
          : [];
        setData(rows);
      } catch {
        setData([]);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [accessToken, enabled]);

  return { data, loading };
}
